// extracted by mini-css-extract-plugin
export default {"typeSelect":"EpicGroupForm_typeSelect__7TAS2","epicGroupNameInput":"EpicGroupForm_epicGroupNameInput__yB108","epicSelect":"EpicGroupForm_epicSelect__5V2Jg"};